exports.getCookie = function (name) {
  const escapedName = name.replace(/([.$?*|{}()[\]\\+^])/g, '\\$1');
  const cookieRegex = new RegExp(`(?:^|; )${escapedName}=([^;]*)`);
  const matches = cookieRegex.exec(document.cookie);

  return matches ? decodeURIComponent(matches[1]) : null;
};

exports.setCookie = function (name, value, options = {}) {
  const _options = { path: '/', ...options };

  if (options.expires instanceof Date) {
    _options.expires = options.expires.toUTCString();
  }

  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  Object.keys(_options).forEach(key => {
    cookie += `; ${key}`;
    const option = _options[key];
    if (option !== true) {
      cookie += `=${option}`;
    }
  });

  document.cookie = cookie;
};
